import React from 'react'
import { useCategoryContext } from '../../Context/categoryContext';
import { useNavigate } from "react-router-dom";
import { isUser } from '../../Config/isUser';
import { isCompany } from '../../Config/isCompany';

const MainCategories = () => {
  const { setCategoryInfo } = useCategoryContext();
  const navigate = useNavigate(); // Sayfa yönlendirme için

  const handleCategoryClick = (e, catItem) => {
    if (isCompany) {
      alert("Tüm ilanları ve kategorileri yalnızca Kişi hesabı görebilir")
    }
    e.preventDefault();
    setCategoryInfo(catItem); // Tıklanan butona göre navInfo'yu ayarla 
    navigate(isUser ? "/all-posts" : (isCompany ? '/' : "/login"))
  };

  return (
    <div className="jp_popular_category_main_wrapper">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div className="jp_popu_cate_heading_wrapper">
              <h4>Popüler Kategoriler</h4>
            </div>
          </div>
          <a onClick={(e) => handleCategoryClick(e, "Satış")} href="/all-posts">
            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div className="jp_popu_cate_box_main_wrapper jp_popu_cate_box_main_wrapper_second">
                <div className="jp_top_jobs_category_wrapper">
                  <div className="jp_top_jobs_category">
                    <i className="fa fa-tags" />
                    <h3>
                      <a onClick={(e) => handleCategoryClick(e, "Satış")} href="/all-posts">Satış</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </a>
          <a onClick={(e) => handleCategoryClick(e, "Pazarlama/Ürün Yönetimi")} href="/all-posts">
            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div className="jp_popu_cate_box_main_wrapper jp_popu_cate_box_main_wrapper_second">
                <div className="jp_top_jobs_category_wrapper">
                  <div className="jp_top_jobs_category">
                    <i className="fa fa-bullhorn" />
                    <h3>
                      <a onClick={(e) => handleCategoryClick(e, "Pazarlama/Ürün Yönetimi")} href="/all-posts">Pazarlama/Ürün Yönetimi</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </a>

          <a onClick={(e) => handleCategoryClick(e, "Teknik Servis")} href="/all-posts">
            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div className="jp_popu_cate_box_main_wrapper jp_popu_cate_box_main_wrapper_second">
                <div className="jp_top_jobs_category_wrapper">
                  <div className="jp_top_jobs_category">
                    <i className="fa fa-wrench" />
                    <h3>
                      <a onClick={(e) => handleCategoryClick(e, "Teknik Servis")} href="/all-posts">Teknik Servis</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </a>

          <a onClick={(e) => handleCategoryClick(e, "Kalite/Belgelendirme/Mevzuat")} href="/all-posts">
            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div className="jp_popu_cate_box_main_wrapper jp_popu_cate_box_main_wrapper_second">
                <div className="jp_top_jobs_category_wrapper">
                  <div className="jp_top_jobs_category">
                    <i className="fa fa-file-text" />
                    <h3>
                      <a onClick={(e) => handleCategoryClick(e, "Kalite/Belgelendirme/Mevzuat")} href="/all-posts">Kalite/Belgelendirme/Mevzuat</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </a>
          <a onClick={(e) => handleCategoryClick(e, "Klinik Destek/Aplikasyon")} href="/all-posts">
            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div className="jp_popu_cate_box_main_wrapper jp_popu_cate_box_main_wrapper2">
                <div className="jp_top_jobs_category_wrapper">
                  <div className="jp_top_jobs_category">
                    <i className="fa fa-stethoscope" />
                    <h3>
                      <a onClick={(e) => handleCategoryClick(e, "Klinik Destek/Aplikasyon")} href="/all-posts">Klinik Destek/Aplikasyon</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </a>
          <a onClick={(e) => handleCategoryClick(e, "Teknoloji Yönetimi")} href="/all-posts">
            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div className="jp_popu_cate_box_main_wrapper jp_popu_cate_box_main_wrapper2">
                <div className="jp_top_jobs_category_wrapper">
                  <div className="jp_top_jobs_category">
                    <i className="fa fa-server" />
                    <h3>
                      <a onClick={(e) => handleCategoryClick(e, "Teknoloji Yönetimi")} href="/all-posts">Teknoloji Yönetimi</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </a>
          <a onClick={(e) => handleCategoryClick(e, "Üretim")} href="/all-posts">
            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div className="jp_popu_cate_box_main_wrapper jp_popu_cate_box_main_wrapper2">
                <div className="jp_top_jobs_category_wrapper">
                  <div className="jp_top_jobs_category">
                    <i className="fa fa-industry" />
                    <h3>
                      <a onClick={(e) => handleCategoryClick(e, "Üretim")} href="/all-posts">Üretim</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </a>
          <a href="/all-posts">
            <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12">
              <div className="jp_popu_cate_box_main_wrapper jp_popu_cate_box_main_wrapper2">
                <div className="jp_top_jobs_category_wrapper">
                  <div className="jp_top_jobs_category">
                    <i className="fa fa-th-large" />
                    <h3>
                      <a href="/all-posts">Tüm ilanlar</a>
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>

  )
}

export default MainCategories